import React, { useEffect, useState, useRef } from 'react';
import Verifiedlist from './verifiedlist';
import { getUser } from './../../../Utils/Common';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { USER_ROLE } from './../../../Utils/appConstants';
import { getRequest } from './../../../Utils/AppApi';
import moment from 'moment';
import { DatePicker, Input, Button, Select } from 'antd';
const { RangePicker } = DatePicker;

function IndexApp(props) {
    const user = getUser();
    const history = useHistory();
    const dateFormat = 'DD-MM-YYYY';

    const modeSelected = useRef(null);
    const accountTypeSelected = useRef(null);

    const [getReportMode, setReportMode] = useState([{ value: 'all', label: 'All' }]);
    const [getRole, setRole] = useState('all');

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateRange, changeDateRange] = useState(null);

    const [roleOrderExist, setRoleOrderExist] = useState(user.data.role.order);

    const [getAccountType, setAccountType] = useState([
        { value: 'all', label: 'All' },
        { value: 'fino', label: 'FINO' },
        { value: 'instant_pay', label: 'Instant Pay' },
        { value: 'fing_pay', label: 'FING Pay' }
    ]);

    const [selectedAccountType, setSelectedAccountType] = useState('all');

    const [checkSubmit, setCheckSubmit] = useState(0);
    
    const [search, setSearch] = useState(null);

    const handleClear = () => {
        setRole('all');
        setSelectedAccountType('all');
        setSearch(null);
        setStartDate(null);
        setEndDate(null);
        changeDateRange(null);
        setCheckSubmit(0);
    };

    const getRoles = () => {
        getRequest(`${USER_ROLE}/${roleOrderExist}`, history)
            .then(async (response) => {
                if (response.success === true) {
                    setReportMode([
                        { value: 'all', label: 'All' },
                        ...response.data.map((item) => ({
                            value: item._id,
                            label: item.name,
                        }))
                    ]);
                } else {
                    toast.error(response.message);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onChangeDatePickerValue = (dates, dateStrings) => {
        setStartDate(dateStrings[0]);
        setEndDate(dateStrings[1]);

        if (dateStrings) {
            changeDateRange([
                moment(dateStrings[0], dateFormat),
                moment(dateStrings[1], dateFormat)
            ]);
        } else {
            changeDateRange(null);
        }
    };

    const onChangeUserType = (value) => {
        setRole(value);
    };

    const onChangeAccountType = (value) => {
        setSelectedAccountType(value);
    };

    const onSearchInput = (value) => {
        setSearch(value);
    };

    const handleSearch = () => {
        setCheckSubmit(checkSubmit + 1);
    };

    useEffect(() => {
        getRoles();
        setRoleOrderExist(user.data.role.order);
    }, []);

    return (
        <div>
            <div className="content-wrapper bg-white pt-4">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid mb-3 ml-2">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>E-Kyc <span className='text-red'>User</span></h1>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-12 d-flex">

                                {/* User Type */}
                                {/* <div className="input-group col-sm-2">
                                    <label className="form-label">User Type:</label>
                                    <Select
                                        options={getReportMode}
                                        className='normal-light w-100'
                                        placeholder="Select a Type"
                                        ref={modeSelected}
                                        onChange={onChangeUserType}
                                        value={getRole}
                                    />
                                </div> */}

                                {/* Date Range */}
                                {/* <div className="input-group col-sm-3">
                                    <label>Date Range:</label>
                                    <RangePicker
                                        format={dateFormat}
                                        allowClear={false}
                                        onChange={onChangeDatePickerValue}
                                        className="col-12"
                                        value={dateRange}
                                    />
                                </div> */}

                                  {/* Account Type */}
                                <div className="input-group col-sm-2">
                                    <label className="form-label">Account Type:</label>
                                    <Select
                                        options={getAccountType}
                                        className='normal-light w-100'
                                        placeholder="Select Account"
                                        ref={accountTypeSelected}
                                        onChange={onChangeAccountType}
                                        value={selectedAccountType}
                                    />
                                </div>

                                {/* Search */}
                                <div className="input-group col-sm-3">
                                    <label className="form-label">Search:</label>
                                    <div className='col-md-12'>
                                        <Input
                                            placeholder="Search ...."
                                            onChange={(e) => onSearchInput(e.target.value)}
                                            value={search}
                                        />
                                    </div>
                                </div>

                              

                                {/* Search + Clear Buttons */}
                                <div className="input-group col-md-2">
                                    <label className="form-label">&nbsp;</label>
                                    <div className='col-md-12'>
                                        <Button type="primary" onClick={handleSearch}>Search</Button>
                                        <Button type="default" onClick={handleClear} className='ml-2'>Clear</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />

                <div className="content">
                    <Verifiedlist
                        mode={getRole}
                        accountType={selectedAccountType}
                        startDate={startDate}
                        endDate={endDate}
                        search={search}
                        handleSearch={checkSubmit}
                    />
                </div>
            </div>
        </div>
    );
}

export default IndexApp;
